import styled from '@emotion/styled';
import { css } from 'twin.macro';

export const RoutesPanel = styled.div`
    position: absolute;
    bottom: 80px;
    left: 10px;
    right: 10px;
    max-width: 400px;
    max-height: 50vh;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    z-index: 10;
    display: flex;
    flex-direction: column;
    margin: 0 auto;

    @media (min-width: 768px) {
        left: 20px;
        right: auto;
        width: 400px;
    }
`;

export const RoutesPanelHeader = styled.div`
    background-color: #24637f;
    color: white;
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 8px;
    }
`;

export const RoutesList = styled.div`
    overflow-y: auto;
    max-height: calc(50vh - 56px);
    padding: 0;
`;

export const RouteItem = styled.div`
    padding: 12px 16px;
    border-bottom: 1px solid #eee;
    display: flex;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    transition: background-color 0.2s;
    position: relative;

    ${(props) =>
        props.isNext &&
        css`
            background-color: rgba(36, 99, 127, 0.1);
            border-left: 4px solid #24637f;
        `}

    &:hover {
        background-color: ${(props) => (props.isNext ? 'rgba(36, 99, 127, 0.15)' : '#f9f9f9')};
    }

    &:last-child {
        border-bottom: none;
    }
`;

export const EventMarker = styled.div`
    width: 40px;
    height: 40px;
    min-width: 40px;
    border-radius: 50%;
    background-color: ${(props) => (props.isNext ? '#24637f' : '#50aeb0')};
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
`;

export const EventDetails = styled.div`
    flex: 1;
    min-width: 0;

    h4 {
        margin: 0 0 4px;
        font-size: 14px;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    p {
        margin: 0;
        font-size: 12px;
        color: #666;
        display: flex;
        align-items: center;
        gap: 4px;
    }

    button {
        flex: 1;
        padding: 6px;
        border: none;
        border-radius: 4px;
        background-color: #24637f;
        color: white;
        font-size: 12px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;

        &:hover {
            background-color: #1a4d63;
        }

        &.secondary {
            background-color: #f0f0f0;
            color: #333;

            &:hover {
                background-color: #e0e0e0;
            }
        }
    }
`;

export const RouteInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    min-width: 70px;

    .eta {
        font-weight: 600;
        color: ${(props) => (props.isNext ? '#24637f' : '#333')};
        font-size: 14px;
    }

    .distance {
        font-size: 12px;
        color: #666;
    }
`;

export const NextEventBadge = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    background-color: #24637f;
    color: white;
    font-size: 10px;
    padding: 2px 6px;
    border-bottom-left-radius: 4px;
`;

export const OngoingEventBadge = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    background-color: var(--danger);
    color: white;
    font-size: 10px;
    padding: 2px 6px;
    border-bottom-left-radius: 4px;
`;

export const NoEventsMessage = styled.div`
    padding: 20px;
    text-align: center;
    color: #666;

    p {
        margin: 8px 0;
    }

    svg {
        font-size: 32px;
        color: #50aeb0;
        margin-bottom: 8px;
    }
`;

export const ToggleButton = styled.button`
    position: absolute;
    bottom: 80px;
    right: 10px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: #24637f;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    cursor: pointer;
    z-index: 10;
    font-size: 24px;

    &:hover {
        background-color: #1a4d63;
    }

    &.active {
        background-color: #50aeb0;
    }
`;

export const InfoWindowContent = styled.div`
    width: 250px;
    padding: 8px;

    h4 {
        margin: 0 0 8px;
        font-size: 16px;
        font-weight: 600;
    }

    p {
        margin: 4px 0;
        font-size: 13px;
        display: flex;
        align-items: center;
        gap: 6px;
    }

    .actions {
        margin-top: 12px;
        display: flex;
        gap: 8px;
    }

    button {
        flex: 1;
        padding: 6px;
        border: none;
        border-radius: 4px;
        background-color: #24637f;
        color: white;
        font-size: 12px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        margin-top: 8px;

        &:hover {
            background-color: #1a4d63;
        }

        &.secondary {
            background-color: #f0f0f0;
            color: #333;

            &:hover {
                background-color: #e0e0e0;
            }
        }
    }
`;

export const LoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 20;

    svg {
        font-size: 32px;
        margin-bottom: 12px;
    }

    p {
        margin: 0;
        color: #333;
        font-weight: 500;
    }
`;
